import type {WorkPrizeWon} from 'api/types';
import type {PartValueRenderer} from 'schema/types';
import {isNullish} from 'schemaDefinition';
import {useCodelist} from 'services/codelists';
import {Builder} from 'services/utils';
import {FlexBox} from 'components';
import {PreviewLinkedEntity} from 'schema/preview';
import {useTextValue} from 'schema/preview/hooks';

export const WorkPrizes: PartValueRenderer = ({value}) => {
  const TextValue = useTextValue();
  const codelist = useCodelist('PRIZE_TYPE');

  return isNullish(value) ||
    !Array.isArray(value) ||
    value.length === 0 ? null : (
    <FlexBox>
      {(value as WorkPrizeWon[]).map((v, i) => {
        const typeLabel = codelist.codes.find(c => c.code === v.type)?.value;
        const agentLink = v.agent.link;
        const prizeLink = v.prize.link;
        const won = new Builder(v.year)
          .add(', ', typeLabel)
          .add('', ': ').value;
        return (
          <FlexBox horizontal key={i} gap={0.5}>
            <TextValue>{won}</TextValue>
            <PreviewLinkedEntity value={agentLink} />
            <TextValue>{', '}</TextValue>
            <PreviewLinkedEntity value={prizeLink} />
          </FlexBox>
        );
      })}
    </FlexBox>
  );
};
